<template>
  <div
    class="uk-grid-small"
    uk-grid
  >
    <div class="uk-width-1-2@s uk-width-1-3@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'blue'"
        :type-status="'orange'"
        :data="String(changeCounts.process || 0)"
        :subtitle="'Data'"
        :status="'Diproses'"
        :route-name="'UpdateData'"
        :query-params="{ status: 'process' }"
      />
    </div>

    <div class="uk-width-1-2@s uk-width-1-3@l">
      <card-status
        :is-loading="isLoading"
        :type-title="'blue'"
        :type-status="'red'"
        :data="String(changeCounts.reject || 0)"
        :subtitle="'Data'"
        :status="'Ditolak'"
        :route-name="'UpdateData'"
        :query-params="{ status: 'reject' }"
      />
    </div>

    <div
      v-if="!isCompanyRole"
      class="uk-width-1-2@s uk-width-1-3@l"
    >
      <card-status
        :is-loading="isLoading"
        :type-title="'blue'"
        :type-status="'green'"
        :data="String(changeCounts.approve || 0)"
        :subtitle="'Data'"
        :status="'Disetujui'"
        :route-name="'UpdateData'"
        :query-params="{ status: 'approve' }"
      />
    </div>
  </div>
</template>

<script>
import CardStatus from '@/components/globals/card/CardStatus'

export default {
  components: {
    CardStatus
  },
  props: {
    isLoading: {
      required: false,
      type: Boolean
    },
    isCompanyRole: {
      required: false,
      type: Boolean,
      default: false
    },
    changeCounts: {
      required: false,
      type: Object,
      default: () => ({})
    }
  }
}
</script>
